import { addressRoutes } from '@services';
import axios from "axios";
const API_BASE_URL = process.env.REACT_APP_ADDRESS_BASE_URL;

const api = axios.create({
    baseURL: API_BASE_URL,
});

export const searchAddressList = async (text:string) => {
    try {
        const response = await api.get(`${addressRoutes.searchAddress}?text=${text}`);
        return response;
    } catch (error) {
        throw error;
    }
};